module.exports = "https://static.im-cdn.com/mjc/storefront/Bright/static/media/Facebook.46e4cbee.svg";